/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { useCSS } from '../../../provider/CSSProvider';
import style from './TimePicker.scss?inline';
import { Tooltip } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useState } from 'react';

export interface TimePickerProps {
  readonly className?: string;
  readonly label?: string;
  readonly required?: boolean; // defaults to false
  readonly step?: number; // defaults to 60s
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onUnfocus?: (currentValue?: string) => void;
}

export function TimePicker({ className, label, value, onChange, required, onUnfocus, step }: TimePickerProps) {
  useCSS(style);

  const [invalidDescription, setInvalidDescription] = useState<string | null>(null);

  return (
    <fieldset className={`timepicker-fieldset ${className ?? ''}`}>
      {label && <legend className='timepicker-legend'>{label}</legend>}
      <input
        type='time'
        className='timepicker-input'
        value={value}
        aria-label={label ?? 'Uhrzeit'}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        onBlur={(event) => {
          const notRequiredHint = !required ? ' oder löschen Sie die Eingabe komplett' : '';
          setInvalidDescription(
            event.target.validity.valid ? null : 'Bitte geben Sie eine vollständige Uhrzeit ein' + notRequiredHint
          );
          if (event.target.validity.valid && onUnfocus) {
            onUnfocus(value);
          }
        }}
        onFocus={() => setInvalidDescription(null)}
        required={required ?? false}
        step={step ?? 60}
      />
      {invalidDescription && (
        <Tooltip arrow title={invalidDescription}>
          <WarningIcon className='warning-symbol' color='warning' />
        </Tooltip>
      )}
    </fieldset>
  );
}
